import { pipe } from 'fp-ts/function';
import { array, number, ord } from 'fp-ts';
import { WithEnterpriseId, WithServiceId } from '@mews-commander/types';
import { createOption } from '@mews-commander/ui';
import { RateGroup, useRepositoryQuery } from '@mews-commander/data-access';

export const useRateGroupsOptions = ({ serviceId, enterpriseId }: WithServiceId & WithEnterpriseId) =>
    useRepositoryQuery(
        'rateGroups',
        'getAll',
        {
            enterpriseIds: [enterpriseId],
            serviceIds: [serviceId],
        },
        {
            select: ({ rateGroups }) =>
                pipe(
                    rateGroups,
                    array.sortBy([byOrdering]),
                    array.map(({ id, name }: RateGroup) => createOption({ value: id, label: name }))
                ),
        }
    );

const byOrdering = pipe(
    number.Ord,
    ord.contramap((rateGroup: RateGroup) => rateGroup.ordering)
);
